import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateChild,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { AuthService } from '../services/auth.service';
import { LotteryAccessService } from '../services/lottery-access.service';

@Injectable({
  providedIn: 'root',
})
export class LotteryMenuGuard implements CanActivateChild {
  constructor(
    private authService: AuthService,
    private lotteryAccessService: LotteryAccessService,
    private router: Router
  ) {}

  async canActivateChild(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<boolean | UrlTree> {
    if (this.authService.isAdmin() || this.authService.isCrypto()) {
      return true;
    }

    const path = state.url.split('?')[0].split('#')[0];
    const allowed = await this.lotteryAccessService.canAccessPath(path);

    if (allowed) {
      return true;
    }

    const redirect = await this.lotteryAccessService.getDeniedRedirectUrl();
    return this.router.parseUrl(redirect);
  }
}